import { render } from "./DashboardBreakdownTable.vue?vue&type=template&id=72eb7ef3&scoped=true"
import script from "./DashboardBreakdownTable.vue?vue&type=script&lang=js"
export * from "./DashboardBreakdownTable.vue?vue&type=script&lang=js"

import "./DashboardBreakdownTable.vue?vue&type=style&index=0&id=72eb7ef3&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72eb7ef3"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QToggle,QTable,QTd,QBadge});
